import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

type TFormalOffer = NonNullable<
    GetFormalOffersResponse['data']
>['formal_offers'];

export const interestOnlyOffer = (
    formal_offers: TFormalOffer
): TFormalOffer[0] | undefined => {
    return formal_offers.find(
        (offer) =>
            offer.product_type === 'credit_facility' &&
            (offer.interest_only_repayments || 0) > 0
    );
};

export const isInterestOnlyOffer = (
    formal_offer: TFormalOffer[0]
): boolean | undefined => {
    return (
        formal_offer.product_type === 'credit_facility' &&
        (formal_offer.interest_only_repayments || 0) > 0
    );
};

export const hasRBLOffer = (formal_offers: TFormalOffer) => {
    return formal_offers.find(
        (offer) => offer.product_type === 'merchant_cash_advance'
    );
};
